(() => {
  const banner = document.getElementById('bbc-install-banner');
  const installButton = document.getElementById('bbc-install-action');
  const closeButton = document.getElementById('bbc-install-close');
  const help = document.getElementById('bbc-install-help');
  if (!banner || !installButton || !closeButton) return;

  const storageKey = 'bbc-install-prompt-dismissed-v1';
  let installEvent = null;
  let helpTimer;
  const installed = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  function dismissed() {
    try { return window.localStorage.getItem(storageKey) === 'yes'; } catch { return false; }
  }

  function hideBanner() {
    banner.hidden = true;
    try { window.localStorage.setItem(storageKey, 'yes'); } catch { /* Storage can be unavailable in private browsing. */ }
  }

  function showInstallHelp() {
    if (!help) return;
    help.hidden = false;
    window.clearTimeout(helpTimer);
    helpTimer = window.setTimeout(() => { help.hidden = true; }, 7000);
  }

  if (!installed && !dismissed()) banner.hidden = false;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installEvent = event;
  });

  installButton.addEventListener('click', async () => {
    hideBanner();
    if (!installEvent) {
      showInstallHelp();
      return;
    }

    const promptEvent = installEvent;
    installEvent = null;
    await promptEvent.prompt();
  });

  closeButton.addEventListener('click', hideBanner);
  window.addEventListener('appinstalled', hideBanner);


})();
